import { render, staticRenderFns } from "./cargoLeftRightResize.vue?vue&type=template&id=a48f9284&scoped=true&"
import script from "./cargoLeftRightResize.vue?vue&type=script&lang=js&"
export * from "./cargoLeftRightResize.vue?vue&type=script&lang=js&"
import style0 from "./cargoLeftRightResize.vue?vue&type=style&index=0&id=a48f9284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48f9284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a48f9284')) {
      api.createRecord('a48f9284', component.options)
    } else {
      api.reload('a48f9284', component.options)
    }
    module.hot.accept("./cargoLeftRightResize.vue?vue&type=template&id=a48f9284&scoped=true&", function () {
      api.rerender('a48f9284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoLeftRightResize.vue"
export default component.exports